/* ==========================================================================
   Expert Help
   Progressive enhancement for the expert-help product block.
   The block renders every configured expert (photo + name) with the first one
   visible and the rest hidden. On each page load this picks one expert at
   random and shows it, hiding the others, so the displayed expert rotates on
   refresh (Crutchfield style). With no JS, the first expert stays visible.
   ========================================================================== */
(function () {
  'use strict';

  class ExpertHelp extends HTMLElement {
    connectedCallback() {
      var people = Array.prototype.slice.call(
        this.querySelectorAll('[data-expert-help-person]')
      );
      if (people.length <= 1) return;

      var chosen = Math.floor(Math.random() * people.length);
      people.forEach(function (person, i) {
        person.classList.toggle('is-hidden', i !== chosen);
      });

      // The tagline under the heading belongs to the chosen expert, not
      // always expert 1. Each figure carries its own tagline (with the
      // default already baked in) in data-credential.
      var credEl = this.querySelector('[data-expert-help-credential]');
      var cred = people[chosen].getAttribute('data-credential');
      if (credEl && cred) credEl.textContent = cred;
    }
  }

  if (!customElements.get('expert-help')) {
    customElements.define('expert-help', ExpertHelp);
  }
})();
